import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_gendoc_to_sales_contract_templates_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  sales_contract_template_guid: fromDatatype.GuidDataFieldInterface;
  gen_doc_template_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  rrul: fromDatatype.VarcharDatatypeInterface;
  offset_value: fromDatatype.IntegerDatatypeInterface;
  subscription_duration_day: fromDatatype.IntegerDatatypeInterface;
  subscription_duration_month: fromDatatype.IntegerDatatypeInterface;
  relative_txn_date_in_months: fromDatatype.IntegerDatatypeInterface;
  relative_txn_date_in_days: fromDatatype.IntegerDatatypeInterface;
  step: fromDatatype.IntegerDatatypeInterface;
  occurrence: fromDatatype.IntegerDatatypeInterface;
  offset_period: fromDatatype.VarcharDatatypeInterface;
  step_period: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_gendoc_to_sales_contract_templates_link_RowClass
  implements bl_fi_gendoc_to_sales_contract_templates_link_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  sales_contract_template_guid: fromDatatype.GuidDataFieldInterface;
  gen_doc_template_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  rrul: fromDatatype.VarcharDatatypeInterface;
  offset_value: fromDatatype.IntegerDatatypeInterface;
  subscription_duration_day: fromDatatype.IntegerDatatypeInterface;
  subscription_duration_month: fromDatatype.IntegerDatatypeInterface;
  relative_txn_date_in_months: fromDatatype.IntegerDatatypeInterface;
  relative_txn_date_in_days: fromDatatype.IntegerDatatypeInterface;
  step: fromDatatype.IntegerDatatypeInterface;
  occurrence: fromDatatype.IntegerDatatypeInterface;
  offset_period: fromDatatype.VarcharDatatypeInterface;
  step_period: fromDatatype.VarcharDatatypeInterface;
}
